import { FormControlLabel, Switch } from '@material-ui/core';
import React, { useState } from 'react';
import { enableFeatureFlag, disableFeatureFlag } from 'services/api/featureFlags';
import FeatureFlagsContext from 'storage/FeatureFlagsContext';

interface FeatureFlagToggleProps {
  flag: string;
  active: boolean;
}

const FeatureFlagToggle = ({ active, flag }: FeatureFlagToggleProps) => {
  const [toggling, setToggling] = useState(false);
  const { reload } = FeatureFlagsContext.useContext();

  const handleToggle = async () => {
    setToggling(true);
    try {
      if (active) {
        await disableFeatureFlag(flag);
      } else {
        await enableFeatureFlag(flag);
      }
    } finally {
      await reload();
      setToggling(false);
    }
  };

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={active ?? false}
            color="primary"
            data-testid={`settings-feature-flag-${flag}`}
            disabled={toggling}
            onChange={handleToggle}
          />
        }
        label={flag}
      />

      <br />
    </>
  );
};

export default FeatureFlagToggle;
